// extracted by mini-css-extract-plugin
export default {"PhoneNumberControl":"RQerWb","phoneNumberControl":"RQerWb"};